import {
  FileOutlined,
  FilePdfOutlined,
  HistoryOutlined,
  UserOutlined
} from "@ant-design/icons"
import { Button, Card, Flex, List, Space, Tag, Typography } from "antd"

import type { DocumentAttachment } from "../../../DocumentTemplates/types/document.types.ts"

const { Title, Text } = Typography

interface ProposalsViewVersionsProps {
  attachments: DocumentAttachment[]
  currentVersionId?: string
  displayDate?: string | null
}

export function ProposalsViewVersions({
  attachments,
  displayDate
}: ProposalsViewVersionsProps) {
  return (
    <Card>
      <Flex align="center" gap="small" className="mb-4">
        <HistoryOutlined className="text-lg " />
        <Title level={5} className="!mb-0">
          Version History
        </Title>
      </Flex>

      <List
        itemLayout="horizontal"
        dataSource={attachments}
        renderItem={(item) => {
          const dateSource = displayDate || item?.created
          const hasDate = Boolean(dateSource)
          const hasFile = Boolean(item.file_url)
          const rightActions =
            hasDate || hasFile ? (
              <Flex key="date-download" vertical align="flex-start" gap="small">
                {hasDate && (
                  <Text type="secondary" className="text-sm whitespace-nowrap">
                    {dateSource}
                  </Text>
                )}
                {hasFile && (
                  <Button
                    type="link"
                    className="!p-0 h-auto !leading-none"
                    href={item.file_url}
                    target="_blank"
                  >
                    Download
                  </Button>
                )}
              </Flex>
            ) : null

          return (
            <List.Item actions={rightActions ? [rightActions] : []}>
              <List.Item.Meta
                avatar={
                  <div className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center">
                    <FilePdfOutlined className="text-xl " />
                  </div>
                }
                title={
                  <Space>
                    <Text strong>
                      Version{" "}
                      {item?.full_version ||
                        item?.extra?.proposal_version_number ||
                        item?.version}
                    </Text>
                    {item.is_submitted && <Tag color={"blue"}>Current</Tag>}
                  </Space>
                }
                description={
                  <Flex vertical gap={4}>
                    <Text type="secondary">{item.file_name}</Text>
                    <Space size="middle">
                      <Space size={4}>
                        <UserOutlined />
                        <Text type="secondary" className="text-xs">
                          {item.uploaded_by_name}
                        </Text>
                      </Space>
                      <Space size={4}>
                        <FileOutlined />
                        <Text type="secondary" className="text-xs">
                          {item.file_type_display}
                        </Text>
                      </Space>
                    </Space>
                  </Flex>
                }
              />
            </List.Item>
          )
        }}
      />
    </Card>
  )
}
